import { useThemeColors, useIsDark } from '@/shared/theme/useThemeColors';
import { typography, zIndex, radius } from '@/shared/theme/tokens';

/**
 * useModalStyles — returns theme-aware overlay + modal container styles.
 * Replaces the old plain-object exports that were hardcoded to light mode.
 *
 * Usage:
 *   const { overlayStyle, modalStyle } = useModalStyles();
 *   <div style={overlayStyle}><div style={modalStyle}>…</div></div>
 *
 * @param {string} [maxWidth='520px']
 */
export function useModalStyles(maxWidth = '520px') {
  const c = useThemeColors();
  const isDark = useIsDark();

  const overlayStyle = {
    position: 'fixed',
    inset: 0,
    background: isDark ? 'rgba(0,0,0,0.6)' : 'rgba(15,23,42,0.45)',
    backdropFilter: 'blur(2px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: zIndex.modal,
    padding: '24px',
    fontFamily: typography.fontFamily.body,
  };

  const modalStyle = {
    background: c.bg,
    borderRadius: radius['3xl'],
    border: `1px solid ${c.borderSubtle}`,
    boxShadow: isDark ? '0 20px 60px rgba(0,0,0,0.5)' : '0 20px 60px rgba(15,23,42,0.18)',
    padding: '28px',
    width: '100%',
    maxWidth,
    maxHeight: '90vh',
    overflowY: 'auto',
  };

  return { overlayStyle, modalStyle };
}
